<script lang="ts">
    import Button from '@smui/button';
    import {Label} from '@smui/common';
    import {contextService, definedMessageService} from './services';
    import {onMount} from 'svelte';
    import type {DefinedMessage, DefinedMessageType} from './types';
    import PrimaryHtmlDefinedMessageEditor from './PrimaryHtmlDefinedMessageEditor.svelte';
    import {v4} from 'uuid';
    import OtherContextInfo from './OtherContextInfo.svelte';
    import {isDefinedMessageOverrideable} from './service/util';

    export let type: DefinedMessageType;

    let definedMessages: DefinedMessage[] = [];

    async function refreshMessages() {
        definedMessages = await definedMessageService.getOfType(type);
    }

    async function saveMessage(event: CustomEvent<DefinedMessage>) {
        await definedMessageService.save(event.detail);
        await refreshMessages();
    }

    async function overrideMessage(definedMessage: DefinedMessage) {
        definedMessages = [...definedMessages, {
            ...definedMessage,
            id: v4(),
            contextId: contextService.getContextId()
        }];
    }

    onMount(async () => await refreshMessages());
</script>

<div>
    {#each definedMessages as definedMessage (definedMessage.id)}
        <div style="display: flex; flex-direction: row; margin-bottom: 20px;">
            <div>
                <OtherContextInfo entity={definedMessage} />
                {#if isDefinedMessageOverrideable(definedMessage, contextService.getContextId())}
                    <div>
                        <Button on:click={() => overrideMessage(definedMessage)} variant="unelevated">
                            <Label>Override</Label>
                        </Button>
                    </div>
                {/if}
            </div>
            <div style="width: 100%;">
                <PrimaryHtmlDefinedMessageEditor definedMessage={definedMessage}
                                                 disabled={isDefinedMessageOverrideable(definedMessage, contextService.getContextId())}
                                                 on:save={saveMessage} />
            </div>
        </div>
    {/each}
</div>